import { render } from "./loading-layer.vue?vue&type=template&id=2540057a"
import script from "./loading-layer.vue?vue&type=script&lang=js"
export * from "./loading-layer.vue?vue&type=script&lang=js"

import "./loading-layer.vue?vue&type=style&index=0&id=2540057a&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__